import type { BusinessAreaLookup } from '../types/business-area-lookup.type';
import { DivisionLookupModel } from './division-lookup.model';
import { GuidNameCodeModel } from './guid-name-code.model';

export class BusinessAreaLookupModel
  extends GuidNameCodeModel
  implements BusinessAreaLookup
{
  readonly divisions: DivisionLookupModel[] | null = null;

  get children(): DivisionLookupModel[] | null {
    return this.divisions;
  }

  constructor(data: BusinessAreaLookup) {
    super(data);

    if (data.divisions) {
      this.divisions = data.divisions.map(
        (item) => new DivisionLookupModel(item),
      );
    }
  }
}
